<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("fnbauditlogs") }}</div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="getAuditLogs"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <b-button variant="default" @click="onFetch()" class="btn-blue">{{
          $t("fetch")
        }}</b-button>
      </div>
    </div>
    <div style="overflow-x: auto; width: 100%">
      <table class="list-view-table" style="overflow-x: auto; width: 100%">
        <thead>
          <tr>
            <th>
              <img
                v-if="this.columnName != 'user_name'"
                @click="onSortValue('user_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('user_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('user_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("user", 1) }} {{ $t("name") }}
            </th>
            <th>{{ $t("field") }} {{ $t("value") }}</th>
            <th>{{ $t("original") }} {{ $t("value") }}</th>
            <th style="width: 100px">{{ $t("new") }} {{ $t("value") }}</th>
            <th>Audit Details</th>
            <th style="width: 110px">
              <img
                v-if="this.columnName != 'created_at'"
                @click="onSortValue('created_at', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('created_at', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('created_at', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("createdat") }}
            </th>
            <th>{{ $t("createdby") }}</th>
          </tr>
        </thead>
        <tbody v-if="FnbAuditLogs.length > 0">
          <tr v-for="(item, key) in FnbAuditLogs" :key="key">
            <td>{{ item.user_name }}</td>
            <td>{{ item.field_changed }}</td>
            <td>{{ item.original_value }}</td>
            <td>{{ item.new_value == null ? "-" : item.new_value }}</td>
            <td>{{ item.audit_details }}</td>
            <td>{{ item.created_at | dateparse }}</td>
            <td>{{ item.created_by }}</td>
          </tr>
        </tbody>
        <tbody v-if="FnbAuditLogs.length == 0">
          <tr>
            <td colspan="7">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-pagination
      v-if="FnbAuditLogs.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemaService from "@/services/CinemasService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      FnbAuditLogs: [],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    // this.getAuditLogs();
    this.getviewingnumber();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onFetch: function () {
      this.getAuditLogs();
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getAuditLogs();
      } else {
        this.currentPage = event;
        this.getAuditLogs();
      }
    },
    goToRoute: function (path, item) {
      this.$router.push({
        path: path,
        query: {
          smm_id: item.smm_id,
          signage_type_id: item.signage_type_id,
        },
      });
    },

    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getAuditLogs();
    },

    getAuditLogs: function () {
      this.FnbAuditLogs = [];
      let loader = this.$loading.show();

      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        auditType: "FnB",
        columnName: this.columnName,
        orderBy: this.orderby,
        searchValue: this.searchValue,
      };

      CinemaService.GetAuditLogs(payload)
        .then((response) => {
          const { data } = response;

          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.FnbAuditLogs = data.Records;

              // this.FnbAuditLogs.map((x, index) => {
              //   this.getViewUsersDetails(x.created_by, index, "created_by");
              // });

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/FnbAuditLogComponents/listgFnBAuditLogs.vue